import { defaultParamsFilter } from "./state";

/**
 * Mutación para restablecer los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDataFilter(state) {
    state.filter = defaultParamsFilter()
}

/**
 * Mutación manipular/alterar los datos del filtro.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataFilter(state, nextState) {
    state.filter = nextState
}